<template>
  <div>
    <template v-if="rows.length == 0 && isLoaded">
      <div class="succes-melding">
        Je bent helemaal up-to-date! Geen nieuwe formulieren ingediend!
      </div>
      <div class="button-extra">
        <Button text="Nieuwe rij toevoegen" @clicked="setNewRow" />
      </div>
    </template>
    <template v-else>
      <Header />
      <div v-for="(row, index) in rows" :key="index">
        <Row
          :input_data="row"
          @deleteRow="deleteRow"
          @sendRow="sendRow"
          @valuesChanged="updateRow"
        />
      </div>
      <div class="button-extra">
        <Button text="Nieuwe rij toevoegen" @clicked="setNewRow" />
      </div>
    </template>
  </div>
</template>

<script>
import Row from "../components/Row.vue";
import Header from "../components/Header.vue";
import Button from "../components/ButtonItem.vue";

import db_methods from "../Database/CRUD.js";

export default {
  name: "App",

  components: {
    Row,
    Header,
    Button,
  },
  data: () => {
    return {
      rows: [],
      isLoaded: false,
    };
  },

  async created() {
    this.rows = await db_methods.getForms();
    this.isLoaded = true;
  },
  methods: {
    async setNewRow() {
      var x = {
        firstname: "",
        lastname: "",
        email: "",
        telefoonnummer: "",
        ondernemer_email: "",
        source_url: "",
        opmerking: "",
      };
      const res = await db_methods.newRow(x);
      x["db_id"] = res.id;
      this.rows.push(x);
    },

    async deleteRow(value) {
      this.rows = this.removeItem(value, this.rows);
      await db_methods.deleteRow(value);
    },

    removeItem(value, arr) {
      const index = arr.findIndex((object) => {
        return object.db_id === value;
      });
      if (index !== -1) {
        arr.splice(index, 1);
      }
      return arr;
    },

    removeFromArray(item, array) {
      var index = array.indexOf(item);
      if (index !== -1) {
        array.splice(index, 1);
      }
      return array;
    },

    updateRow(value) {
      const id = value.db_id;
      var array = Object.assign({}, value);
      delete array.db_id;

      db_methods.updateRow(id, value);
    },

    async sendRow(value) {
      const row = await db_methods.getRow(value);
      await this.axios.post(
        "https://angelsandvc.com/api_req/request-form2.php",
        {
          voornaam: row.firstname,
          achternaam: row.lastname,
          email: row.email,
          opmerking: row.opmerking,
          email_ondernemer: row.ondernemer_email,
          telefoonnummer: row.telefoonnummer,
          source_url: row.source_url,
        }
      );
      this.deleteRow(value);
    },
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  padding: 5%;
}

.succes-melding {
  text-align: center;
  width: 100%;
  font-size: 40px;
}

.button-extra {
  justify-content: flex-start;
  margin: 2% 0px 0px -50px;
}
</style>
